import React from 'react';
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import Grid from "@mui/material/Grid";
import useEquipmentDetailsStyles from './styles';
import { Box } from '@mui/material';
import FilledInput from "@mui/material/FilledInput";
import InputAdornment from "@mui/material/InputAdornment";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

import useCustomTextFieldStyles from './styles';

const CustomTextField = ({ value, onChange, label, id, error, helperText, Adornmenttype, Adornmentlabel, Adornmentposition, disabled, type }) => {
  const classes = useCustomTextFieldStyles();
  return <div className={classes.root}>
    {
      Adornmenttype === true ?
        <div>
          <FormControl sx={{ width: "100%" }}>
            <InputLabel htmlFor="filled-adornment-password">
              {label}
            </InputLabel>
            <FilledInput
              classes={{
                root: "MuiInputBase-root-MuiFilledInput-root",
              }}
              id={id}
              value={value}
              type={type}
              // step={0.5}
              disabled={disabled}
              onChange={onChange}
              error={error}
              endAdornment={
                <InputAdornment position={Adornmentposition}>
                  {Adornmentlabel}
                </InputAdornment>
              }
              aria-describedby="filled-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
                disableUnderline: true,
              }}
            />
          </FormControl>
          {error && helperText &&
            <div style={{ fontSize: 12, color: 'red', marginLeft: '20px' }}>{helperText}</div>
          }
        </div>
        :
        <>
          <TextField
            label={label}
            id={id}
            value={value}
            onChange={onChange}
            error={error}
            disabled={disabled}
             type={type}
            // helperText={helperText}
            InputProps={{
              disableUnderline: true,
              style: {
                borderRadius: "50px",
                backgroundColor: "#fff",
                boxShadow: error ? "4px 4px 15px rgba(244, 67, 54, 0.3)" : "4px 4px 15px rgba(0, 0, 0, 0.05)",
              },
            }}
            sx={{
              '& .MuiFilledInput-root': {
                borderBottom: error ? '2px solid #f44336' : 'none',
              },
              '& .MuiOutlinedInput-root': {
                borderColor: error ? '#f44336 !important' : 'transparent',
              },
            }}
          />
          {error && helperText &&
            <div style={{ fontSize: 12, color: 'red', marginLeft: '20px' }}>{helperText}</div>
          }
        </>
    }
  </div>;
};

CustomTextField.propTypes = {};

export default CustomTextField;
